/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
/* eslint-disable no-redeclare */
import { ModalLayoutTokens } from '@cp/ds/src/components/modalLayout';
import { LitElement, css, html, unsafeCSS } from 'lit';

export class Drawer extends LitElement {
  #dialog: HTMLDialogElement;
  static properties = {
    open: { type: Boolean },
    onClose: { type: Function },
    onClosed: { type: Function },
  };

  constructor() {
    super();
  }

  render() {
    return html`<dialog class="${this.open ? 'is-open' : ''}"><slot></slot></dialog>`;
  }

  updated(changed: Map<string, unknown>) {
    if (changed.has('open')) {
      if (this.open) {
        requestAnimationFrame(() => this.#dialog.showModal());
      } else {
        requestAnimationFrame(() => this.#dialog.close());
      }
    }
  }

  firstUpdated(_) {
    super.firstUpdated(_);
    this.#dialog = this.renderRoot.querySelector('dialog') as HTMLDialogElement;
    this.#dialog.addEventListener('click', (event) => {
      if (event.target === this.#dialog) {
        this.onClose?.();
      }
    });
    this.#dialog.addEventListener('close', () => {
      this.onClosed?.();
    });
  }

  static styles = css`
    :host {
      display: block;
    }
    dialog {
      border: none;
      padding: 0;
      margin: 0;
      width: 700px;
      height: 100dvh;
      max-height: 100dvh;
      //position: fixed;
      inset: 0 auto 0 0;
      transform: translateX(-100%);
      transition: transform 300ms cubic-bezier(0, 0, 0.2, 1);
      background-color: ${unsafeCSS(ModalLayoutTokens.PaperColor())};
    }

    :host([anchor='right']) dialog {
      inset: 0 0 0 auto;
      transform: translateX(100%);
    }

    :host([anchor='bottom']) dialog {
      width: 100%;
      height: auto;
      inset: auto 0 0 0;
      transform: translateY(100%);
      border-top-left-radius: ${unsafeCSS(ModalLayoutTokens.Radius())};
      border-top-right-radius: ${unsafeCSS(ModalLayoutTokens.Radius())};
    }

    dialog.is-open {
      transform: translate(0, 0) !important;
    }

    dialog::backdrop {
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    dialog.is-open::backdrop {
      opacity: 1;
    }
  `;

  static register(name = 'yh-drawer') {
    if (!customElements.get(name)) {
      customElements.define(name, Drawer);
    }
  }
}

if (typeof customElements !== 'undefined') {
  Drawer.register();
}
export interface Drawer {
  open: boolean;
  anchor: string;
  onClose?: () => void;
  onClosed?: () => void;
}
